import { render, staticRenderFns } from "./waybillDetail.vue?vue&type=template&id=31729cf6&scoped=true"
import script from "./waybillDetail.vue?vue&type=script&lang=js"
export * from "./waybillDetail.vue?vue&type=script&lang=js"
import style0 from "./waybillDetail.vue?vue&type=style&index=0&id=31729cf6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31729cf6",
  null
  
)

export default component.exports